export default "__VITE_ASSET__5084757b__"